import { graphql, type HeadFC } from 'gatsby';
import React from 'react';

import type { PageContext } from 'src/components/common/page-context';
import { PageHead } from 'src/components/common/page-head';
import { GenericFormContent } from 'src/components/enquiry/generic-form-content';
import type Seo from 'src/models/global/seo-content';

type GenericFormPageProps = {
  data: GenericFormPageData;
};

type GenericFormPageData = {
  json: {
    name: string;
    genericFormPageContent: Queries.GenericFormPageContent;
    seo: Seo;
  };
};

export const query = graphql`
  query GenericFormPage(
    $id: String
    $clubDirectoryName: String
    $clubId: String!
    $globalDirectoryName: String!
    $language: String!
  ) {
    json: genericFormPageJson(id: { eq: $id }) {
      name
      seo {
        pageTitle
        pageDescription
      }
      genericFormPageContent {
        formUiElements {
          ..._FormUiElements
        }
        formSettings {
          ..._FormSettings
        }
        content {
          ..._GenericPageContentUnion
          ..._ClubContactInfo
        }
      }
    }
    ..._ClubCmsRecordCore
    ..._ClubCmsRecordPromotions
    ..._GlobalCmsRecord
  }
`;

const GenericFormPage: React.FC<GenericFormPageProps> = ({ data }: GenericFormPageProps) => {
  const { genericFormPageContent, name } = data.json;

  return <GenericFormContent content={genericFormPageContent} name={name} />;
};

export default GenericFormPage;

export const Head: HeadFC<GenericFormPageData, { id: string; baseContext: PageContext }> = ({
  data,
  pageContext,
}) => (
  <PageHead
    pageContext={pageContext.baseContext}
    seo={{
      titleOverride: data.json.seo.pageTitle,
      descriptionOverride: data.json.seo.pageDescription,
    }}
  />
);
